import { FormGridField } from "../../components/FormGrid";

export interface InputSearchDefinition {
    name: string;
    id: string;
    label: string;
    searchAction: any;
    items: any;
    selectedFilters: any;
    schemaName: string;
    fieldOverrides?: any;
    buildFormGridField: (schema) => FormGridField;
}

export default function buildInputSearchDefinition({
    name,
    id,
    label,
    searchAction,
    items,
    selectedFilters,
    schemaName,
    fieldOverrides,
}: {
    name: string;
    id: string;
    label: string;
    searchAction: any;
    items: any;
    selectedFilters: any;
    schemaName: string;
    fieldOverrides?: any;
}): InputSearchDefinition {
    return {
        name,
        id,
        label,
        searchAction,
        items,
        selectedFilters,
        schemaName,
        fieldOverrides,
        buildFormGridField: _createInputSearchField
    };
}

function _createInputSearchField(schema): FormGridField {
    const {
        name,
        id,
        label,
        searchAction,
        items,
        selectedFilters,
        schemaName,
        fieldOverrides
    } = this;

    return {
        name,
        fieldType: "inputSearch",
        fieldOptions: {
            id,
            label,
            searchAction,
            items,
            selectedFilters,
        },
        validationSchema: {
            ...schema.properties[schemaName],
            required: schema.hasOwnProperty("required")
                ? schema.required.includes(name)
                : false
        },
        columnClass: "col-12",
        formSpacing: true,
        ...fieldOverrides
    };
}
